<template>
<div class="col padtb0" @click="snackbar =false">
    <div class="card_information show" id="card_information" v-if="loaded">
        <h3 v-if="!updatecard">Card Information 
            <span class="biling_edit" v-if="!updatecard && customerCardDetails " @click="updatecard =true">
                <svg xmlns="http://www.w3.org/2000/svg" width="17.494" height="17.526" viewBox="0 0 17.494 17.526">
                  <path id="edit" d="M17.494,2.736A2.739,2.739,0,0,0,12.816.8L1.787,11.875A3.282,3.282,0,0,0,1,13.158l-.01.031L0,17.524l4.346-.972.028-.012a3.287,3.287,0,0,0,1.284-.793l11.03-11.08A2.722,2.722,0,0,0,17.494,2.736ZM2.41,15.582l-.461-.461.332-1.458,1.6,1.591ZM15.724,3.708,5.016,14.458l-1.939-1.94,7.334-7.364,1.117,1.117L12.5,5.3,11.371,4.185,12.412,3.14l1.121,1.121.968-.968L13.379,2.17l.4-.4A1.372,1.372,0,1,1,15.72,3.707ZM7.2,16.141h10.3v1.367H5.831Zm0,0" transform="translate(0 0.002)" fill="#48648b"/>
                </svg>                          
            </span>
            <!-- <button  type="button" @click="updatecard =true" class="primary-btn">Edit Card </button> -->
        </h3>
        <h3 v-if="updatecard">Update Card Information</h3>
        <template v-if="loaded && ( userplan ==null) || (userplan && updatecard) || (customerCardDetails == null) ">
            <div class="form"  >
                <div class='credit-card-inputs payment-simple d-block' :class='{ complete }'>
                    <div class="card_form pb-3">
                        
                            <div class="form-group num">
                                <label class="form_label">Card Number</label>
                                <div class="form-control">

                                    <card-number class='stripe-element card-number' ref='cardNumber' :stripe='stripe' :options='options' @change='number = $event.complete' />
                                </div>
                            </div>
                            <div class="form-group date">
                                <label class="form_label">Expiry Date</label>
                                <div class="form-control">
                                    <card-expiry class='stripe-element card-expiry' ref='cardExpiry' :stripe='stripe' :options='options' @change='expiry = $event.complete' />
                                </div>
                            </div>
                            <div class="form-group cvv">
                                <label class="form_label d-flex">CVC<p>
                                        <img src="@/assets/images/icons/info_btn.png"><small>A CVC is the 3 digit number from the back or 4 digit number on the front of the card.</small>
                                    </p></label>
                                <div class="form-control">
                                    <card-cvc class='stripe-element card-cvc' ref='cardCvc' :stripe='stripe' :options='options' @change='cvc = $event.complete' />
                                </div>
                            </div>
                    </div>
                        
                    <div class="terms_check terms_checkv2">
                    <vs-checkbox
                      v-model="licenseAggrement"
                      data-vv-as="License Agreement"
                      name="licenseAggrement"
                      v-validate="'required'"
                    ></vs-checkbox>
                    <p>
                        I agree to the
                      <a target="_blank" :href="this.$globalgonfig._PAYMENT_TERMS">payment terms</a
                      >
                    </p>

                    <span
                    v-if="showTermscondErr && !licenseAggrement"
                      class="error-text"
                      style="color: #ff2727"
                 
                      >* You must agree payment Terms</span
                    >
                    </div>
                        <!-----Apply Cupon Code ---->

                    <div class="card_actions justify-start pt-3">
                        <button v-if="updatecard && customerCardDetails" class="cancel_btn" @click="updatecard =false" id="cancel_btn">Cancel</button>
                        <button  type="button" @click="completepayment()" :disabled="!checkProperty(selectedPlan ,'_id') || paymentSaving " class="update_btn">
                        <template v-if="!checkProperty(userplan ,'_id') && !customerCardDetails"> Proceed </template>
                         <template v-else> Update</template>
                        <figure v-if="paymentSaving"  class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
                        
                        </button>
                        <!-- <button v-if="updatecard" type="button" @click="updateCardDetails()" class="update_btn">Update</button> -->
                        
                    </div>
                        
                    
                    <!-- <div class="coupons_sec" v-if="!updatecard">
                        <a v-if="!applyCuponCode" @click="applyCuponCode=true" > Do you have coupon code?</a>
                        <div class="coupons__form" v-if="applyCuponCode">
                            <label class="form_label">Cuppon Code</label>
                            <div class="form-group">                            
                                <input type="text" placeholder="Enter Coupon Code" class="form-control" name="cuppon code" v-model="cuponCode" v-validate="'required'|'max:15'|'min:10'">
                                <button :disabled="!cuponCode" class="update_btn" @click="checkCuponvalidation()"> Apply </button>
                            </div> 
                        </div>
                        <div  class="error-text" v-if="cuponValidationMsg!='' && validCoupon">Congratulations - You have got ${{cuponValidationMsg}} offer on your selected package</div>
                        <div  class="error-text" v-if="cuponValidationMsg!='' && cuponError">{{cuponValidationMsg}}</div>
                    </div> -->


                    
                </div>
            </div> 
        </template>
       
        <!-- <template v-else>
            <div class="card_view">
                <ul>
                    <li>
                        <label>Card Number</label>
                        <p>XXXX XXXX XXXX</p>
                    </li>
                    <li>
                        <label>Expire Date</label>
                        <p>** / **</p>
                    </li>
                    <li>
                        <label>CVV</label>
                        <p>***</p>
                    </li>
                </ul>
                <button  type="button" @click="updatecard =true" class="primary-btn">Edit Card </button>
            </div>
        </template> -->
        <template  v-else-if="customerCardDetails && checkProperty(customerCardDetails, 'paymentMethod') && checkProperty(customerCardDetails, 'paymentMethod', 'card') && checkProperty(customerCardDetails['paymentMethod'], 'card', 'last4')">
            <div class="card_view_wrap">
                <div class="card_cnt">
                    <span class="card_icon">
                        <img :src="paymentUrl">
                    </span>
                    <div class="card_info">
                        <label><em>**** **** ****</em>{{checkProperty(customerCardDetails['paymentMethod'], 'card', 'last4')}}</label>
                        <div class="d-flex align-center">
                            <span>Expiry Date {{returnExpiryMonth(checkProperty(customerCardDetails['paymentMethod'], 'card', 'exp_month'))}}/{{returnExpiryYear(checkProperty(customerCardDetails['paymentMethod'], 'card', 'exp_year'))}}</span>
                        <span>CVC 
                            <em v-if="checkProperty(customerCardDetails['paymentMethod'], 'card', 'brand') == 'American Express'">****</em>
                            <em v-else>***</em>
                        </span>
                        </div>
                    </div>
                   
                </div>
                
            </div>
            <!-- {{getActiveCardInfo}} -->
             <!-- <div class="form"  >
                <div class='credit-card-inputs payment-simple' :class='{ complete }'>
                    <div class="card_form edit_card">
                        
                            <div class="form-group num">
                                <label class="form_label">Card Number</label>
                                <div class="form-control">
                                    <vs-input readonly="readonly" class='stripe-element card-number' ref='cardNumber' :value="'XXXX XXXX XXXX '+checkProperty(getActiveCardInfo ,'last4')" />
                                </div>
                            </div>
                            <div class="form-group date">
                                <label class="form_label">Expiry Date</label>
                                <div class="form-control">
                                    <vs-input readonly="readonly" class='stripe-element card-expiry' ref='cardExpiry' value="** / **" />
                                </div>
                            </div>
                            <div class="form-group cvv">
                                <label class="form_label d-flex">CVC<p>
                                        <img src="@/assets/images/icons/info_btn.png"><small>A CVC is the 3 digit number from the back or 4 digit number on the front of the card.</small>
                                    </p></label>
                                <div class="form-control">
                                    <vs-input readonly="readonly" class='stripe-element card-cvc' ref='cardCvc' value="***"  />
                                </div>
                            </div>
                    </div>
                        

                       
                        
                    <div class="card_actions">
                       
                        <button  type="button" @click="updatecard =true" class="edit-btn"><img src="@/assets/images/main/edit_icon.svg"> Edit Card </button>
                       
                        
                    </div>
       
                        
                                       
                </div>
            </div> -->
        </template>
      
    </div>
   


    <!-- <div>
        

        <label>Card</label>
        <div id="card-element">

        </div>
    </div> -->
</div>
</template>

<script>
import {
    CardNumber,
    CardExpiry,
    CardCvc,
    createSource
} from '@noahlozevski/vue-stripe-elements-plus'
import moment from "moment";
import VuePhoneNumberInput from "vue-phone-number-input";
import addressFields from "@/views/forms/fields/address.vue";



export default {
    provide() {
    return {
      parentValidator: this.$validator,
    };
  },
    computed: {
    getIsCardExists(){
      return this.$store.getters['subscription/getIsCardExists']
    },
    getActiveCardInfo(){
        let activeCardInfo = null;
         let cardDetails =  this.$store.getters['subscription/getactiveCardList'];
      
        if(this.checkProperty( cardDetails ,"length") >0){
                    let latestCard = cardDetails[0];
                      
                     if(this.checkProperty( latestCard ,"source" ,"card")){
                        activeCardInfo = latestCard['source']['card'];
                        // alert(JSON.stringify(activeCardInfo)) 
                      
                     }
                      
                 }
        return activeCardInfo // activeCardInfo;

    },
    
    },
    props: ['stripe', 'userplan', "cancelbtn","selectedPlan", 'tenantDetails' ],
    data() {
        return { 
            paymentUrl:'',
            customerCardDetails:null,
            showTermscondErr:false,
            licenseAggrement:false,
            updatecard:false,
            stripeAPIToken: 'pk_test_pZnhKyNDKZ7mQJR6cfQxTHe600TzKSwrOg',
    
               // stripe: '',
                elements: '',
                card: ''
                ,
            cuponError: false,
            cuponValidationMsg: '',
            cuponCode: "",
            validCoupon: false,
            applyCuponCode: false,

            options: {
                style: {
                    base: {

                        iconColor: '#c4f0ff',
                        color: '#8790B1',
                        fontSize: "13px",
                        fontWeight: '500',
                        padding: 15,
                        fontSmoothing: 'antialiased',
                        ':-webkit-autofill': {
                            color: '#8790B1',
                        },
                        '::placeholder': {
                            color: '#8790B1',
                        },
                    },
                    invalid: {
                        iconColor: '#FFC7EE',
                        color: '#FF8F00',
                    },
                },
            },
            complete: false,
            number: false,
            expiry: false,
            cvc: false,
            showoverlay: false,
            toasteshow: false,
            toastecontent: null,
            text: null,
            snackbar: false,
            isError: false,
            showsuccess: null,
            messagetitle: null,
            messagecontent: null,
            paymentSaving:false,
            formSubmited: false,
            completeTenantprofile: false,
            loaded:false,

        }
    },
    components: {
        CardNumber,
        CardExpiry,
        CardCvc,
        VuePhoneNumberInput,
        addressFields
       
    },
    mounted() {
        if(this.checkProperty(this.tenantDetails, 'payTermsAccepted')){
            this.showTermscondErr = false;
            this.licenseAggrement = true;
        } 
        this.stripeAPIToken = this.$globalgonfig.STRIPKEY;
        // this.isAddressSame()
        this.getCustomerCardDetails(true)
       

    },
    methods: {
        returnExpiryYear(year){
            let data = year
            if(String(data).length > 2){
                return data % 100
            }else{
                return data
            }
            return data
        },
        returnExpiryMonth(mon){
            let data = mon
            if(String(data).length == 1){
                data = '0'+data
                return data
            }else{
                return data
            }
            return data
        },
        getCustomerCardDetails(callFromMount = false){
            let path = '/billing/get-customer-details';
            let payload = {
                subscriber:{
                    name: this.checkProperty(this.tenantDetails , "adminName"),
                    email: this.checkProperty(this.tenantDetails , "adminEmail"),
                    phone: this.checkProperty(this.tenantDetails , "phone"),
                    phoneCode: this.checkProperty(this.tenantDetails , "phoneCountryCode" ,"countryCallingCode")
                }
            }
            this.loaded = false;
            this.$store.dispatch('subscription/subscribeCommonAction', {data:payload,path:path}).then((resp)=>{
                if(resp){
                    let cadrImg = '';
                   
                    let webBaseUrl = window.location.origin;
                    let cardBaseUrl = window.location.origin
                    if(webBaseUrl.includes('localhost') || webBaseUrl.includes('anyclap') || webBaseUrl.includes('192') ){
                        cardBaseUrl = 'https://anyclap.com'
                    }
                    if(this.checkProperty(resp, 'paymentMethod', 'card') && this.checkProperty(resp['paymentMethod'], 'card', 'cardImg')){
                        this.paymentUrl = cardBaseUrl+'/paymentsbeta/common/viewfile?path='+this.checkProperty(resp['paymentMethod'], 'card', 'cardImg')
                    }
                }
                
                this.customerCardDetails = resp;
                if(callFromMount){
                    if(resp && resp != null ){
                        this.updatecard = false
                    }
                }
                this.loaded = true;
            }).catch((er)=>{
                this.updatecard = true
                this.loaded = true;
            })
        },
        reload(){
            
            this.$emit('reload');
        },
        paymentTermsConditions(){
            let payload={};
            this.$store.dispatch('commonAction', {data:payload,path:'/tenant/pay-terms-accepted'}).then((resp)=>{

            }).catch((er)=>{})
        },
       
        checkCuponvalidation() {
            var user = this.$store.state.user;
            this.showoverlay = true;
              var _self = this;
              let tenantDetails = _self.checkProperty(user , "tenantDetails")
             let subscriber = {
                    name: _self.checkProperty(tenantDetails , "adminName"),
                    email: _self.checkProperty(tenantDetails , "adminEmail"),
                    phone: _self.checkProperty(tenantDetails , "phone"),
                    phoneCode: _self.checkProperty(tenantDetails , "phoneCountryCode" ,"countryCallingCode")
                }
              
            //cuponError
            //  cuponValidationMsg:'',
            // cuponCode:"FLAT30",
            // validCoupon:false,
            // applyCuponCode:false,
            this.cuponError = false;
            this.validCoupon = false;
            this.cuponValidationMsg = "";
         
            let payLoad = {
                "planId": (_self.userplan!=null)?_self.userplan._id:_self.selectedPlan.planId,
                "code": this.cuponCode,
                subscriber: subscriber,
                  today: moment(new Date()).format("YYYY-MM-DD"),
                    timezone: moment.tz.guess(),
                    browserTS: moment(new Date())

            };
            this.$store.dispatch("subscription/validateCupon", payLoad)
                .then((res) => {
                    this.showoverlay = false;
                    this.cuponError = false;
                    this.validCoupon = true;
                    this.cuponValidationMsg = res["amount"];

                })
                .catch((err) => {
                    this.showoverlay = false;
                    this.cuponError = true;
                    this.validCoupon = false;
                    this.cuponValidationMsg = err;

                });

        },
        updateCardDetails() {
            this.text = null;
            this.showoverlay = true;
            this.snackbar = false;
            var user = this.$store.state.user;
            var _self = this;
            let tenantDetails = _self.checkProperty(user , "tenantDetails")
            

           let subscriber = {
                    name: _self.checkProperty(tenantDetails , "adminName"),
                    email: _self.checkProperty(tenantDetails , "adminEmail"),
                    phone: _self.checkProperty(tenantDetails , "phone"),
                    phoneCode: _self.checkProperty(tenantDetails , "phoneCountryCode" ,"countryCallingCode")
                }

             
            createSource().then(result => {

                var payLoad = {
                    selPlanIds: [],
                    plans: [],
                    source: null,
                    "serviceTypeId": 1,
                    "methodTypeId": 1,
                    "newSource": true,
                    subscriber:subscriber,
                    today: moment(new Date()).format("YYYY-MM-DD"),
                    timezone: moment.tz.guess(),
                    browserTS: moment(new Date())
                };
                var paymethod = payLoad;

                paymethod.source = result.source;
                this.$store.dispatch("subscription/attachpaymentmethod", paymethod).then((cardResponse) => {

                    this.showoverlay = false;
                    this.toasteshow = true;
                    this.toastecontent = "Card details are updated successfully";
                    this.showToster({message:this.toastecontent ,isError:false});

                }).catch((err) => {
                    this.showoverlay = false;
                    this.text = "Please enter valid card details";
                    this.isError = true;
                    this.snackbar = true;
                     this.showToster({message: this.text ,isError:true});

                });

            })

        },
        cancelop() {
            this.$emit('cancelop', true)
        },
        checkBillingdetailsExist(){
            let obj = {
                    name: this.checkProperty(this.tenantDetails , "adminName"),
                    email: this.checkProperty(this.tenantDetails , "adminEmail"),
                    phone: this.checkProperty(this.tenantDetails , "phone"),
                    phoneCode: this.checkProperty(this.tenantDetails , "phoneCountryCode" ,"countryCallingCode"),
                    billingDetails:{
                        busName:'',
                        authPerson:{
                            name:'',
                            email:'',
                            phone:'',
                            phoneCountryCode:{
                            countryCode:'IN',
                            countryCallingCode:'91'
                            },
                            address: {
                            line1: "",
                            line2: "",
                            countryId: '',
                            countryDetails: null,
                            stateId: "",
                            locationId: "",
                            zipcode: "",

                            stateDetails: null,
                            locationDetails: null,
                            aptType: '',
                        },
                
                    }
                }
            }
            if(_.has(this.tenantDetails,'billingDetails') && this.checkProperty(this.tenantDetails,'billingDetails') && this.checkProperty(this.tenantDetails['billingDetails'], 'busName') ){
                if(_.has(this.tenantDetails['billingDetails'], 'busName')){
                    obj['billingDetails']['busName'] = this.tenantDetails['billingDetails']['busName']
                }
                if(_.has(this.tenantDetails['billingDetails'], 'authPerson')){
                    if(_.has(this.tenantDetails['billingDetails']['authPerson'], 'name')){
                        obj['billingDetails']['authPerson']['name'] = this.tenantDetails['billingDetails']['authPerson']['name']
                    }
                    if(_.has(this.tenantDetails['billingDetails']['authPerson'], 'email')){
                        obj['billingDetails']['authPerson']['email'] = this.tenantDetails['billingDetails']['authPerson']['email']
                    }
                    if(_.has(this.tenantDetails['billingDetails']['authPerson'],'phone')){
                        obj['billingDetails']['authPerson']['phone'] =  this.tenantDetails['billingDetails']['authPerson']['phone']
                    }
                    if(_.has(this.tenantDetails['billingDetails']['authPerson'], 'phoneCountryCode')){
                        if(_.has(this.tenantDetails['billingDetails']['authPerson']['phoneCountryCode'], 'countryCode')){
                            obj['billingDetails']['authPerson']['phoneCountryCode']['countryCode'] = this.tenantDetails['billingDetails']['authPerson']['phoneCountryCode']['countryCode']
                        }
                        if(_.has(this.tenantDetails['billingDetails']['authPerson']['phoneCountryCode'], 'countryCallingCode')){
                            obj['billingDetails']['authPerson']['phoneCountryCode']['countryCallingCode'] = this.tenantDetails['billingDetails']['authPerson']['phoneCountryCode']['countryCallingCode']
                        }
                    }
                    if (_.has(this.tenantDetails['billingDetails']['authPerson'], "address")) {
                        let dt = this.tenantDetails['billingDetails']['authPerson']['address']
                        obj['billingDetails']['authPerson']["address"] = _.cloneDeep(dt);
                    }

                }
            }else if(_.has(this.tenantDetails,'name') && this.checkProperty(this.tenantDetails, 'name')){
                if(_.has(this.tenantDetails,'name') && this.checkProperty(this.tenantDetails, 'name')){
                    obj['billingDetails']['busName'] = this.tenantDetails['name']
                }
                if(_.has(this.tenantDetails,'adminName') && this.checkProperty(this.tenantDetails, 'adminName')){
                    obj['billingDetails']['authPerson']['name'] =  this.tenantDetails['adminName']
                }
                if(_.has(this.tenantDetails,'adminEmail') && this.checkProperty(this.tenantDetails, 'adminEmail')){
                    obj['billingDetails']['authPerson']['email'] =  this.tenantDetails['adminEmail']
                }
                if(_.has(this.tenantDetails,'phone') && this.checkProperty(this.tenantDetails, 'phone')){
                    obj['billingDetails']['authPerson']['phone'] =  this.tenantDetails['phone']
                    if(_.has(this.tenantDetails,'phone') && this.checkProperty(this.tenantDetails, 'phoneCountryCode')){
                    if(_.has(this.tenantDetails,'phoneCountryCode') && this.checkProperty(this.tenantDetails, 'phoneCountryCode', 'countryCode')){
                        obj['billingDetails']['authPerson']['phoneCountryCode']['countryCode'] =  this.tenantDetails['phoneCountryCode']['countryCode']
                    }
                    if(_.has(this.tenantDetails,'phoneCountryCode') && this.checkProperty(this.tenantDetails, 'phoneCountryCode', 'countryCallingCode')){
                        obj['billingDetails']['authPerson']['phoneCountryCode']['countryCallingCode'] =  this.tenantDetails['phoneCountryCode']['countryCallingCode']
                    }
                    }
                }
                if(_.has(this.tenantDetails,'adminEmail') && this.checkProperty(this.tenantDetails, 'adminEmail')){
                    obj['billingDetails']['authPerson']['email'] =  this.tenantDetails['adminEmail']
                }
                if(_.has(this.tenantDetails,'address') && this.checkProperty(this.tenantDetails, 'address')){
                    let dt = this.tenantDetails['address']
                    obj['billingDetails']['authPerson']['address'] =  _.cloneDeep(dt);
                }
            };
            return obj;
        },
        completepayment() {
            this.showTermscondErr = false
            if(this.licenseAggrement){
                this.showoverlay = true;
        var user = this.$store.state.user;
        var _self = this;
        this.text = null;
        this.snackbar = false;
            let tenantDetails = _self.checkProperty(user , "tenantDetails")
            let subscriber = {
                name: _self.checkProperty(tenantDetails , "adminName"),
                email: _self.checkProperty(tenantDetails , "adminEmail"),
                phone: _self.checkProperty(tenantDetails , "phone"),
                phoneCode: _self.checkProperty(tenantDetails , "phoneCountryCode" ,"countryCallingCode")
            }
        this.paymentSaving =true;    
        createSource().then(result => {
            


            var payLoad = {
                selPlanIds: [],
                plans: [],
                source: null,
                serviceTypeId: 1,
                methodTypeId: 1,
                newSource: true,
                subscriber: this.checkBillingdetailsExist(),
                today: moment(new Date()).format("YYYY-MM-DD"),
                timezone: moment.tz.guess(),
                browserTS: moment(new Date()),
                
            };
            var paymethod = payLoad;
            var chargepayload = payLoad;
                    
                    
            

                    payLoad.plans.push({
                        planId: _self.selectedPlan._id,
                        criteria: _self.selectedPlan.criteria,
                        frequencyDays: 0,

                    })

                    chargepayload.source = result.source;

                    paymethod.source = result.source;
                    this.$store.dispatch("subscription/attachpaymentmethod", paymethod).then((cardResponse) => {
                        if(!this.checkProperty(this.tenantDetails, 'payTermsAccepted') && this.licenseAggrement ){
                            this.paymentTermsConditions();
                        }

                            var payLoad = {
                            subscriber:subscriber,
                                plans: [],
                            page: 1,
                            perpage: 100,
                            appActivity: true,
                            today: moment(new Date()).format("YYYY-MM-DD"),
                            timezone: moment.tz.guess(),
                            browserTS: moment(new Date()),
                            };
                            
                            payLoad.plans.push({
                                planId: _self.selectedPlan._id,
                                criteria: _self.selectedPlan.criteria,
                                frequencyDays: 0,

                            })

                            this.$store.dispatch("subscription/cardDetails", payLoad).then((cardResponse) => {
                            
                            })

                                    if(this.userplan ==null){
                                        this.$store.dispatch("subscription/subscribe", payLoad).then((res) => {
                                                this.paymentSaving =false;
                                                
                                            if (res) {
                                                chargepayload.selPlanIds = res._id;
                                                this.showToster({message:res.message ,isError:false});
                                                this.getCustomerCardDetails()
                                                    this.reload();  
                                            }else{
                                                this.showToster({message:"somthing went wrong" ,isError:true})
                                            }

                                            // if (this.validCoupon && this.cuponCode) {
                                            //     chargepayload = Object.assign(chargepayload, {
                                            //         "code": this.cuponCode
                                            //     });
                                            // }

                                        }).catch((error)=>{
                                            this.showToster({message:error.message ,isError:true})
                                        })
                                    }else{
                                        this.paymentSaving =false; 
                                        this.getCustomerCardDetails()
                                        this.reload(); 
                                        this.showToster({message:cardResponse.message ,isError:false});
                                        this.cancelop();

                                    }
                                    

                    }).catch((err) => {
                        this.showoverlay = false;
                            
                        this.text = "Please enter valid card details";
                        this.isError = true;
                        this.snackbar = true;
                            this.showToster({message:'Please enter valid card details' ,isError:true})
                            this.paymentSaving =false; 
                            //  this.reload(); 

                    });

        })
            }else{
                this.showTermscondErr = true
            }
        },
        update() {
            this.complete = this.number && this.expiry && this.cvc

            // field completed, find field to focus next
            if (this.number) {
                if (!this.expiry) {
                    this.$refs.cardExpiry.focus()
                } else if (!this.cvc) {
                    this.$refs.cardCvc.focus()
                }
            } else if (this.expiry) {
                if (!this.cvc) {
                    this.$refs.cardCvc.focus()
                } else if (!this.number) {
                    this.$refs.cardNumber.focus()
                }
            }
            // no focus magic for the CVC field as it gets complete with three
            // numbers, but can also have four
        }
    },
    watch: {
        number() {
            this.update()
        },
        expiry() {
            this.update()
        },
        cvc() {
            this.update()
        }
    }
}
</script> 

<style>

</style>
